'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactToastify = require('react-toastify');
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
require('react-toastify/dist/ReactToastify.css');
var _Transition = require('./Transition');
var _Transition2 = _interopRequireDefault(_Transition);
var _underscore = require('underscore');
var _underscore2 = _interopRequireDefault(_underscore);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ToastContainerBase = function (_React$Component) {
  _inherits(ToastContainerBase, _React$Component);
  function ToastContainerBase(props) {
    _classCallCheck(this, ToastContainerBase);
    var _this = _possibleConstructorReturn(this, (ToastContainerBase.__proto__ || Object.getPrototypeOf(ToastContainerBase)).call(this, props));
    _this.toastComponentOptions = {
      closeButton: false,
      draggable: false,
      hideProgressBar: true
    };
    return _this;
  }
  _createClass(ToastContainerBase, [{
    key: 'shouldComponentUpdate',
    value: function () {
      function shouldComponentUpdate(nextProps) {
        if (_underscore2['default'].isEqual(Object.keys(this.props), Object.keys(nextProps)) && _underscore2['default'].isEqual(_underscore2['default'].omit(this.props, [_underscore2['default'].functions(this.props)]), _underscore2['default'].omit(nextProps, [_underscore2['default'].functions(nextProps)]))) {
          var _arr = [].concat(_toConsumableArray(_underscore2['default'].functions(this.props)));
          for (var _i = 0; _i < _arr.length; _i++) {
            var i = _arr[_i];
            if (!_underscore2['default'].isEqual(this.props[i].toString(), nextProps[i].toString())) {
              return true;
            }
          }
          return false;
        }
        return true;
      }
      return shouldComponentUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        _reactToastify.toast.dismiss();
      }
      return componentWillUnmount;
    }()
  }, {
    key: 'render',
    value: function () {
      function render() {
        return _react2['default'].createElement(_reactToastify.ToastContainer, _extends({}, this.props, this.toastComponentOptions));
      }
      return render;
    }()
  }]);
  return ToastContainerBase;
}(_react2['default'].Component);
ToastContainerBase.propTypes = {
  /**
   * position for toasts
   */
  position: _propTypes2['default'].oneOf(['top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left']),
  /**
   * pause the timer on hovering toast
   */
  pauseOnHover: _propTypes2['default'].bool,
  /**
   * pause the timer when window is not active
   */
  pauseOnFocusLoss: _propTypes2['default'].bool,
  /**
   * right to left or left to right
   */
  rtl: _propTypes2['default'].bool,
  /**
   * whether toast should be closed by clicking on it
   */
  closeOnClick: _propTypes2['default'].bool,
  /**
   * whether new toasts should be displayed on top of stack
   */
  newestOnTop: _propTypes2['default'].bool,
  /**
   * time in milliseconds for auto closing the toast
   */
  autoClose: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
  /**
   *className for styling
   */
  className: _propTypes2['default'].string,
  /**
   * Transition function (exported)
   */
  transition: _propTypes2['default'].func
};
ToastContainerBase.defaultProps = {
  position: 'top-center',
  pauseOnHover: true,
  pauseOnFocusLoss: true,
  rtl: false,
  closeOnClick: false,
  newestOnTop: true,
  autoClose: false,
  transition: (0, _Transition2['default'])('slide-enter', 'slide-exit', [1500, 1500], false)
};
ToastContainerBase.displayName = 'ToastContainer';
exports['default'] = ToastContainerBase;